/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import e from "../../core/Logger.js";
import { equals as r } from "../../geometry/support/spatialReferenceUtils.js";
import { getMimeTypeFormatId as t, getFilenameFormatId as i } from "./infoFor3D.js";
import { getEffectiveLayerCapabilities as s, getEffectiveEditingEnabled as a } from "./layerUtils.js";
function o(e) {
  return !(!(e && "object" == typeof e && "loaded" in e && e.loaded && s(e)?.operations?.supportsEditing && "type" in e) || "editingEnabled" in e && !a(e) || "scene" === e.type && !n(e));
}
function n(s) {
  const {
      associatedLayer: a
    } = s,
    o = a?.infoFor3D;
  if (!!!o) return !0;
  const {
      supportedFormats: n,
      queryFormats: l
    } = o,
    d = t("model/gltf-binary", n) ?? i("glb", n);
  if (!(null != d && l.includes(d))) return e.getLogger("esri.layers.support.editableLayers").warnOnce(`SceneLayer (${s.title ?? "Untitled layer"}, ${s.id}) is not editable because it does not support GLB queries.`), !1;
  const c = s.spatialReference,
    p = a.spatialReference;
  if (!r(c, p)) return e.getLogger("esri.layers.support.editableLayers").warnOnce(`SceneLayer (${s.title ?? "Untitled layer"}, ${s.id}) is not editable because its spatial reference (wkid:${c.wkid}) is different from its associated FeatureLayer's spatial reference (wkid:${p.wkid}).`), !1;
  const f = a.sourceJSON.sourceSpatialReference;
  return !(null != f && !r(f, p)) || (e.getLogger("esri.layers.support.editableLayers").warnOnce(`SceneLayer (${s.title ?? "Untitled layer"}, ${s.id}) is not editable because the spatial reference of its associated FeatureLayer's service (wkid:${p.wkid}) is different from its source spatial reference (wkid:${f.wkid}).`), !1);
}
export { o as isEditableLayer };